// extracted by mini-css-extract-plugin
export default {"cls1":"ButtonsPage-cls1_Ibt","cls2":"ButtonsPage-cls2_MJs ButtonsPage-cls1_Ibt","show":"ButtonsPage-show_fL_"};